//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from "@/request/index";
import footerNav from "@/components/footerNav";
import { Dialog, Toast, Notify } from "vant";
import zwtp from "../../assets/img/zwtp.png";

export default {
  name: "centerOrder",
  components: {
    footerNav
  },
  data() {
    return {
      num: 0,
      numList: [],
      searchValue: "",
      loading: false,
      refreshing: false,
      finished: false,
      zwtp,
      start: 0,
      size: 0,
      numList: [],
      itemList: []
    };
  },
  created() {},
  mounted() {
    this.onLoad();
  },
  methods: {
    GridCheck(item) {
      item.checked = !item.checked;
      this.itemList.forEach(item => {
        item.isShow = false;
        item.isDelect = false;
      });
      this.itemList.forEach(item => {
        if (item.checked) {
          this.numList.forEach(element => {
            if (item.sampleId == element.sampleId) {
              item.isShow = true;
            }
          });
          if (!item.isShow) {
            this.numList.push(item);
          }
        } else {
          this.numList.forEach(element => {
            if (item.sampleId == element.sampleId) {
              element.isDelect = true;
            }
          });
          this.numList = this.numList.filter(item => {
            return !item.isDelect;
          });
        }
      });
      sessionStorage.setItem("numList", JSON.stringify(this.numList));
      this.num = this.numList.length;
    },
    onSearch() {
      sessionStorage.setItem("numList", JSON.stringify(this.numList));
      var params = {
        sampleNoList: this.searchValue == "" ? [] : this.searchValue.split(" "),
        start: this.start,
        size: this.size,
        orderRules: [
          {
            orderKey: "sampleNo",
            desc: true
          }
        ]
      };
      axiosApi.getSampleinfoQueryList(params).then(response => {
        if (
          response.content &&
          response.content.list &&
          response.content.list.length > 0
        ) {
          response.content.list.forEach(item => {
            item.checked = false;
            if (
              item.predictedCost &&
              item.predictedCost != "" &&
              item.predictedCost != null
            ) {
            } else {
              item.predictedCost = "暂无";
            }
          });
          var List = JSON.parse(sessionStorage.getItem("numList"));
          this.itemList.splice(0, this.itemList.length);
          this.itemList = response.content.list;
          this.itemList.forEach(item => {
            List.forEach(element => {
              if (element.sampleId == item.sampleId) {
                item.checked = element.checked;
              }
            });
          });
        } else {
          this.itemList = [];
        }
        this.loading = false;
        this.refreshing = false;
        if (this.itemList.length == response.content.total) {
          this.finished = true;
        }
      });
    },
    onLoad() {
      sessionStorage.setItem("numList", JSON.stringify(this.numList));
      this.size = this.size + 20;
      axiosApi
        .getSampleinfoQueryList({
          start: this.start,
          size: this.size,
          sampleNoList:
            this.searchValue == "" ? [] : this.searchValue.split(" "),
          orderRules: [
            {
              orderKey: "sampleNo",
              desc: true
            }
          ]
        })
        .then(response => {
          if (
            response.content &&
            response.content.list &&
            response.content.list.length > 0
          ) {
            response.content.list.forEach(item => {
              item.checked = false;
              if (
                item.predictedCost &&
                item.predictedCost != "" &&
                item.predictedCost != null
              ) {
              } else {
                item.predictedCost = "暂无";
              }
            });
            var List = JSON.parse(sessionStorage.getItem("numList"));
            this.itemList.splice(0, this.itemList.length);
            this.itemList = response.content.list;
            this.itemList.forEach(item => {
              List.forEach(element => {
                if (element.sampleId == item.sampleId) {
                  item.checked = element.checked;
                }
              });
            });
          } else {
            this.itemList = [];
          }
          this.refreshing = false;
          this.loading = false;
          if (this.itemList.length == response.content.total) {
            this.finished = true;
          }
        });
    },
    bottomClick() {
      var List = JSON.parse(sessionStorage.getItem("numList"));
      if (this.num != 0 && List.length != 0) {
        this.$router.push({
          name: "activities",
          query: { itemList: JSON.stringify(List) }
        });
      } else {
        Notify({ type: "danger", message: "请选择" });
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/centerOrder/index.vue